import React, { useState } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { positions, transitions, Provider as AlertProvider } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
import styled from 'styled-components';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { Helmet } from 'react-helmet';
import { NotFound } from './presentation/pages/NotFound';
import { ScrollTop } from './presentation/components/templates/ScrollTop';
import topRoutes from './presentation/router/Top';
import applyRoutes from './presentation/router/Apply';
import adminRoutes from './presentation/router/Admin';
import homeRoutes from './presentation/router/Home';
import Styled from './presentation/theme/Styled';
import * as Constants from './presentation/common/constants';
import { BarWithMenuIcon, SideMenu, BarWithTitle } from './presentation/components';
import { AuthProvider, MasterProvider, ClinicProvider } from './model/hooks';
import container from './di_container/tsyringe.config';
import { InjectionProvider } from './di_container/InjectionProvider';
import { RedirectCheckChlinic, RedirectCheckAdmin } from './presentation/components/templates';
const Container = Styled.div `
  min-height: 100%;
  background: ${(props) => props.theme.background};
  color: ${(props) => props.theme.color};
`;
const useStyles = makeStyles((theme) => createStyles({
    // home以下画面の共通レイアウト
    homeContainer: {
        paddingTop: '32px',
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${Constants.DRAWER_WIDTH + 50}px)`,
            marginLeft: Constants.DRAWER_WIDTH,
            paddingLeft: '24px',
            paddingRight: '24px',
        },
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '12px',
            paddingRight: '12px',
        },
    },
}));
// メッセージ(react-alert)の設定
const whiteSpace = 'pre-wrap';
const alertOptions = {
    position: positions.TOP_CENTER,
    timeout: 5000,
    offset: '30px',
    transition: transitions.FADE,
    containerStyle: { whiteSpace, zIndex: 9999 },
};
const App = () => {
    return (React.createElement(InjectionProvider, { container: container },
        React.createElement(SAlertProvider, Object.assign({ template: AlertTemplate }, alertOptions),
            React.createElement(StripeProvider, { apiKey: process.env.REACT_APP_STRIPE_API_KEY },
                React.createElement(Elements, null,
                    React.createElement(AuthProvider, null,
                        React.createElement(MasterProvider, null,
                            React.createElement(ClinicProvider, null,
                                React.createElement(AppRouter, null)))))))));
};
const AppRouter = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [isOpenMenu, setIsOpenMenu] = useState(false);
    const toggleMenu = () => setIsOpenMenu(!isOpenMenu);
    return (React.createElement(Container, null,
        React.createElement(BrowserRouter, null,
            React.createElement(Switch, null,
                topRoutes.map((config, i) => (React.createElement(Route, { key: i, path: config.path, exact: config.exact, children: config.children }))),
                React.createElement(Route, { path: "/home", render: ({ match: { url } }) => (React.createElement(React.Fragment, null,
                        React.createElement(BarWithMenuIcon, { onClickIcon: toggleMenu }),
                        React.createElement(SideMenu, { isOpen: isOpenMenu, onClose: toggleMenu }),
                        React.createElement(ScrollTop, null),
                        React.createElement(RedirectCheckChlinic, null),
                        React.createElement("div", { className: classes.homeContainer },
                            React.createElement(Switch, null, homeRoutes.map((config, i) => (React.createElement(Route, { key: i, path: `${url}${config.path}`, exact: config.exact, children: config.children }))))))) }),
                React.createElement(Route, { path: "/apply", render: ({ match: { url } }) => (React.createElement(React.Fragment, null,
                        React.createElement(Helmet, null,
                            React.createElement("title", null, "IMORY\u30AF\u30EA\u30CB\u30C3\u30AF\u7533\u8ACB")),
                        React.createElement(BarWithTitle, null, t('IMORY')),
                        React.createElement(Switch, null, applyRoutes.map((config, i) => (React.createElement(Route, { key: i, path: `${url}${config.path}`, exact: config.exact, children: config.children })))))) }),
                React.createElement(Route, { path: "/admin", render: ({ match: { url } }) => (React.createElement(React.Fragment, null,
                        React.createElement(BarWithTitle, null, t('IMORY管理画面')),
                        React.createElement(RedirectCheckAdmin, null),
                        React.createElement(Switch, null, adminRoutes.map((config, i) => (React.createElement(Route, { key: i, path: `${url}${config.path}`, exact: config.exact, children: config.children })))))) }),
                React.createElement(Route, { path: "*", component: NotFound })))));
};
const SAlertProvider = styled(AlertProvider) `
  div > div {
    background-color: ${Constants.COLOR.ORANGE700} !important;
    font-weight: bold;
  }
`;
export default App;
